import React from 'react'

const ImageGenerateAds = () => {
      return (
            <>
                  <a
                        href="https://heyprompt.online/ai-image-generator"
                        target="_blank"
                        rel="noreferrer"
                        style={{

                              display: "flex", alignItems: "center", gap: "14px",
                              background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
                              borderRadius: "12px", padding: "14px 18px", margin: "20px 0 22px",
                              textDecoration: "none", border: "1px solid rgba(255,255,255,0.08)",
                              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                        }}
                  >
                        <div style={{
                              width: "44px", height: "44px", borderRadius: "10px",
                              background: "linear-gradient(135deg, #a855f7, #6366f1)",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: "22px", flexShrink: 0,
                        }}>
                              <img className='w-100 h-100' style={{objectFit: 'contain'}} src="https://heyprompt.online/apple-touch-icon.png" alt='heyprompt-logo'/>
                        </div>
                        <div style={{ flex: 1 }}>
                              <div style={{ color: "#fff", fontWeight: "700", fontSize: "14px", marginBottom: "2px" }}>
                                    Free AI Image Generator
                              </div>
                              <div style={{ color: "rgba(255,255,255,0.55)", fontSize: "12px" }}>
                                    Login & create stunning images — heyprompt.online
                              </div>
                        </div>
                        <div style={{
                              background: "linear-gradient(135deg, #a855f7, #6366f1)",
                              color: "#fff", fontSize: "11px", fontWeight: "700",
                              padding: "5px 12px", borderRadius: "20px", whiteSpace: "nowrap",
                        }}>Try Free →</div>
                  </a>
            </>
      )
}

export default ImageGenerateAds